var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PSection',{attrs:{"game-info":"","theme":"white"}},[_c('div',{staticClass:"contents-holder"},[_c('div',{staticClass:"left-holder"},[_c('BattleAcademiaItems')],1),_c('div',{staticClass:"right-holder"},[_c('BattleAcademiaRanking')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }